/** Calendar helpers: week math, Google event time parsing, layout constants. */
export const HOUR_PX = 48;
export const DAY_START = 6;
export const DAY_END = 22;

export const startOfWeek = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); x.setDate(x.getDate() - x.getDay()); return x; };
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
export const evStart = (e) => new Date(e.start?.dateTime || `${e.start?.date}T00:00:00`);
export const evEnd = (e) => new Date(e.end?.dateTime || `${e.end?.date}T00:00:00`);
export const isAllDay = (e) => !e.start?.dateTime;
export const fmtTime = (d) => d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
export const pad = (n) => String(n).padStart(2, '0');
export const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
